import React, {Component} from 'react';
import {APP_VERSION, BUILD_VERSION} from "../util/constants";

class Footer extends Component {

    render() {

        return (
            <div>
                <footer className="footer">
                    <ul>
                        <li><a href="#" title="VuePay">{`v${APP_VERSION}`}</a></li>
                        <li><a href="/" title="VuePay" className="icon"></a></li>
                        <li><a href="mailto:support@vuepay.com" title="Contact us">Contact us</a></li>
                        <li><a href="https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/EULA/privacy.html" title="Privacy policy" target="_blank">Privacy policy</a></li>
                        <li><a href="https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/EULA/terms.html" title="Terms and conditions" target="_blank">Terms and conditions</a></li>
                    </ul>
                </footer>
            </div>
        );
    }
}


export default Footer